export default __webpack_public_path__ + "static/media/Group-3406_blue_Tata.46b89ee2.png";